import React from 'react';
import WName, {WArticle} from '../WName';
import Eon from '../Eon';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {
  E1, E2, Qual,
  imagine_a_shift,
  SwearMaybe,
} from '../common';

// We DO NOT know ourself
export const know_thyself = {
  name: "know thyself",
  alternatives: "ourself",
  header: <span>
    On the Ἀπολλώνιον was written, ‘Γνῶθι σεαυτόν.’ Collectively, we <i>do not</i>.
  </span>,
  outside: <span>
    The Ἀπολλώνιον (Apollōnion) was the temple of <AL name="religion.greek">Apollo</AL> at Delphi, cf. <NW>ziggurat</NW> (or 𒂍/é). ‘Γνῶθι σεαυτόν’ (gnōthi seauton) is <QL name="languages">Ancient Greek</QL> for, ‘Know thyself.’
  </span>,
  preview: <div className="problem-preview">
    <p>Think <AL name="religion.jain.kevala">केवल ज्ञान</AL> (kevala jñāna: supreme wisdom), think ‘ubwenge’ (a <QL name="languages">Kinyarwanda</QL> word for ‘<QL>consciousness</QL>’, or for ‘<QL>wisdom</QL>’), or think Polonius from ‘<AL name="notnew.shakespeare">Hamlet</AL>’: to <QL name="authenticity">thine own</QL> <AL name="you">self</AL> be true.</p>
    <p>And then let’s <i><PL name="denial">admit</PL></i>, <LRL name="gaia">together</LRL>, that as a planetary <NW>POC</NW> we really rather fall short when it comes to this one.</p>
  </div>,
  text: <div className="problem-text">
    <p>There are various reasons for our collective failure:</p>
    <ul>
      <li>Our <QL>polygnosticity</QL> from one ‘<QL name="other">another</QL>’.</li>
      <li>Which is <QL name="isolation">exacerbated</QL> by <PL>privacy</PL>: the <LRL>literal</LRL>, non-<PL name="metaphysics">metaphysical</PL> and non-<NW word="mythology">mythological</NW> ‘<PL name="privacy.">Devil</PL>’.</li>
      <li>And we are held <QL name="tm">(Forever)Apart<sup>®</sup></QL> by our collective <AL name="limits">inability</AL> (under <NW word="lama toosin">𐒐𐒖𐒑𐒖 𐒂𐒝𐒈𐒘𐒒</NW>, cf <NW>BOLT</NW>) to <NW word="overcome">Ganzesystemüberwindung</NW> beyond <NW word="jorm">Jörmungandr</NW>).</li>
      <li>etc., etc.</li>
    </ul>
    <p>This all ties into why it is so <i><PL>hard</PL></i> (for <QL name="mean.hominids">DieHominiede</QL><sup>™</sup> of <NW>kennis-apartheid</NW>) to <LRL>understand</LRL>; <QL name="tm">Living<sup>®</sup></QL> in <NW>BOLT</NW>, <QL name="readers.">jeetjet</QL> must do <QL name="tm">AbsolutelyEverything<sup>®</sup></QL> <i>all by jeetjetself</i>. <AL name="fields.logic.">QED</AL>.</p>
  </div>,
};
